<label>
  <div class="form-field__label form-field__summary-label">
    {{ field?.label | translateInline }}
  </div>

  <div class="form-field__summary form-field__summary-amount">
    {{ content$ | async | i18n_currency: (currency$ | async) }}
  </div>
</label>
